// @ts-nocheck
import * as React from "react";

const TheRequirementsOutline: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" aria-hidden="true" focusable="false">
            <path
                d="M41.5 70.2h34
                   M35.2 70.2c0 2.9-2.4 5.3-5.3 5.3-3 0-5.3-2.4-5.3-5.3s2.4-5.3 5.3-5.3c2.9-.1 5.3 2.3 5.3 5.3z
                   M41.5 50h34
                   M41.5 29.8h34
                   M35.2 29.8c0 2.9-2.4 5.3-5.3 5.3-3 0-5.3-2.4-5.3-5.3s2.4-5.3 5.3-5.3 5.3 2.4 5.3 5.3z
                   M35.2 50c0 3-2.4 5.3-5.3 5.3-3 0-5.3-2.4-5.3-5.3s2.4-5.3 5.3-5.3 5.3 2.3 5.3 5.3z"
                fill="none"
                stroke="currentColor"
                strokeMiterlimit="10"
                strokeWidth="2"
            />
        </svg>
    );
};

export default React.memo(TheRequirementsOutline);
